import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import FullReportManagement from '../components/FullReportManagement.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import AppInfoManagement from '../components/AppInfoManagement.vue'
import DisplayImageManagement from '../components/DisplayImageManagement.vue'
import DataDashboard from '../components/DataDashboard.vue'
import UserManagement from '../components/UserManagement.vue'  // 用户管理组件导入
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'  // 用户提现管理组件导入
import AdminManagement from '../components/AdminManagement.vue'  // 管理员管理组件导入
import GoodsManagement from '../components/GoodsManagement.vue'  // 自营商城-商品管理
import GoodsCategoryManagement from '../components/GoodsCategoryManagement.vue'  // 分类管理
import ExternalMallManagement from '../components/ExternalMallManagement.vue'  // 外链商城-商品管理

import RiskManagement from '../components/RiskManagement.vue'  // 风控管理
import ExchangeOrderManagement from '../components/ExchangeOrderManagement.vue'  // 兑换订单管理
import CoinFlowManagement from '../components/CoinFlowManagement.vue'  // 金币明细
import AdPoolSettlementManagement from '../components/AdPoolSettlementManagement.vue'  // 副广池结算流水
import AgentDailyRevenue from '../components/AgentDailyRevenue.vue'  // 团长每日收益
import NoticeSendManagement from '../components/NoticeSendManagement.vue'  // 超管发通知
import AgentNoticeManagement from '../components/AgentNoticeManagement.vue'  // 代理转发通知
import { getHomePath } from '../utils/tagsView'

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const router = new Router({
  mode: 'history', // 添加这一行以启用history模式
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/data-dashboard',
      name: 'DataDashboard',
      component: DataDashboard
    },
    {
      path: '/main',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: () => getHomePath()
        },
        {
          path: '/ad-revenue',
          name: 'AdRevenueQuery',
          component: AdRevenueQuery
        },
        {
          path: '/full-report',
          name: 'FullReportManagement',
          component: FullReportManagement,
          meta: {
            title: '报表管理'
          }
        },
        {
          path: '/system/config',
          name: 'SystemConfigManagement',
          component: SystemConfigManagement
        },
        {
          path: '/system/app',
          name: 'AppInfoManagement',
          component: AppInfoManagement
        },
        {
          path: '/system/display-image',
          name: 'DisplayImageManagement',
          component: DisplayImageManagement,
          meta: {
            title: '展示图管理'
          }
        },
        {
          path: '/user-management',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/user-withdrawal',
          name: 'UserWithdrawalManagement',
          component: UserWithdrawalManagement
        },
        {
          path: '/admin-management',
          name: 'AdminManagement',
          component: AdminManagement
        },
        {
          path: '/mall/goods',
          name: 'GoodsManagement',
          component: GoodsManagement,
          meta: {
            title: '自营商品管理'
          }
        },
        {
          path: '/mall/external-goods',
          name: 'ExternalMallManagement',
          component: ExternalMallManagement,
          meta: {
            title: '外链商品管理'
          }
        },
        {
          path: '/mall/categories',
          name: 'GoodsCategoryManagement',
          component: GoodsCategoryManagement,
          meta: {
            title: '分类管理'
          }
        },

        {
          path: '/mall/exchange-order',
          name: 'ExchangeOrderManagement',
          component: ExchangeOrderManagement,
          meta: {
            title: '兑换订单管理'
          }
        },
        {
          path: '/risk-management',
          name: 'RiskManagement',
          component: RiskManagement,
          meta: {
            title: '风控管理'
          }
        },
        {
          path: '/coin-flow',
          name: 'CoinFlowManagement',
          component: CoinFlowManagement,
          meta: {
            title: '金币明细'
          }
        },
        {
          path: '/ad-pool-settlement',
          name: 'AdPoolSettlementManagement',
          component: AdPoolSettlementManagement,
          meta: {
            title: '副广池结算'
          }
        },
        {
          path: '/agent-daily-revenue',
          name: 'AgentDailyRevenue',
          component: AgentDailyRevenue,
          meta: {
            title: '团长收益'
          }
        },
        {
          path: '/notice-send',
          name: 'NoticeSendManagement',
          component: NoticeSendManagement,
          meta: {
            title: '消息通知'
          }
        },
        {
          path: '/agent-notice',
          name: 'AgentNoticeManagement',
          component: AgentNoticeManagement,
          meta: {
            title: '消息通知'
          }
        }
      ]
    }
  ]
})

// 需要超级管理员(role=0)权限的路由
const superAdminOnlyRoutes = [
  '/ad-revenue',
  '/data-dashboard',
  '/system/config',
  '/system/app',
  '/system/display-image',
  '/admin-management',
  '/risk-management',
  '/mall/goods',
  '/mall/external-goods',
  '/mall/categories',
  '/mall/exchange-order',
  '/coin-flow',
  '/notice-send'
]

// 普通管理员不可进入：app 管理、风控管理、代理专属页
const ordinaryAdminDeniedRoutes = [
  '/system/config',
  '/system/app',
  '/system/display-image',
  '/risk-management',
  '/mall/goods',
  '/mall/external-goods',
  '/mall/categories',
  '/mall/exchange-order',
  '/agent-daily-revenue',
  '/agent-notice'
]

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const role = parseInt(localStorage.getItem('role')) || 0

  if (to.path === '/login') {
    // 如果去的是登录页，且已经有 token，直接跳转到主页
    if (token) {
      next(getHomePath())
    } else {
      next()
    }
  } else if (to.path === '/') {
    // 访问根路径时，根据是否有 token 决定去向
    if (token) {
      next(getHomePath())
    } else {
      next('/login')
    }
  } else {
    // 如果去的是受保护路由，检查是否有 token
    if (token) {
      // 普通管理员不能进入 app 管理、风控管理
      if (role === 3 && ordinaryAdminDeniedRoutes.some(path => to.path.startsWith(path))) {
        next(getHomePath())
      // 代理(role=1或2)访问超级管理员页面时，跳到代理首页
      } else if ((role === 1 || role === 2) && superAdminOnlyRoutes.some(path => to.path.startsWith(path))) {
        next(getHomePath())
      } else {
        next()
      }
    } else {
      // 没有 token，跳转到登录页
      next('/login')
    }
  }
})

export default router